import { Component, Input, inject } from '@angular/core';
import {IProgressBarStep} from '../../interfaces';
import {Router} from '@angular/router';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    standalone: false
})
export class ProgressBarComponent {
    private router = inject(Router);


    @Input() public progress: number;
    @Input() public steps: IProgressBarStep[] = [];

    public setStep(step) {
        this.router.navigate(step);
    }

}
